import { useState, useContext, useEffect } from 'react';
import Context from '../../../context/appContext';
import { getUrl, getDependencyValue, getKeys, getDateFormat, getValueTypePerson, getValueField } from '../../../utils/utils';
import { Modal, Form } from 'antd'
import moment from 'moment';
import TextField from '../text';

export default function ValidateField({ info, form, key, current }) {

    const { customRequest, setCheckOption, dataForm: { data, formResponses, hiddenFields, disabledFields }, setIsValidPerson, setDataForm, setLoadingProcedure, loadingProcedure } = useContext(Context);
    const logic = info && info.logic && info.logic[0] ? info.logic[0] : [];
    const json = logic.trigger && logic.trigger.json ? JSON.parse(JSON.stringify(logic.trigger.json)) : {};
    const isContratante = json && json.key && json.key === 'Contratante';

    useEffect(() => {
        json.action && json.action === 'update' && onClick();
        setDataForm({ data, formResponses, hiddenFields: hiddenFields, disabledFields });
    }, []);

    const onClick = async () => {
        setLoadingProcedure({ visible: true, message: "Validando RFC..." })
        if (Object.keys(json).length > 0 && json.action) {
            if (json.action === 'autocomplete') {
                const opciones_servicio = getUrl(JSON.stringify(json), formResponses);
                const response = await customRequest(opciones_servicio.url, opciones_servicio.headers,
                    opciones_servicio.method, opciones_servicio.body);
                if (response) {
                    if (response.nombreExcepcion || response.status) {
                        enableFields();
                        configModal('No hemos encontrado los datos en nuestro sistema. Por favor completa el formulario', 'Aceptar', 'Ops!');
                        setIsValidPerson(false)
                    } else {
                        setIsValidPerson(true)
                        const keyLcl = opciones_servicio && opciones_servicio.key ? opciones_servicio.key : null;
                        autoComplete(response, keyLcl);
                    }
                }
            }
        }
        setLoadingProcedure({ ...loadingProcedure, visible: false })
    }

    const configModal = (message, btnOk, title) => {
        Modal.info({
            icon: '',
            title: title,
            className: 'modal-confirm',
            closable: false,
            okButtonProps: {
                className: 'ant-btn-solid c-2 ant-btn-size-xs margin-s'
            },
            okText: btnOk,
            content: <p>{message}</p>,
            onOk() { }
        });
    }

    const setInternalIdentifier = (dataI) => {
        const fValue = dataI && dataI.numeroInterno;
        const nField = { key: 'internalIdentifierContratante', value: fValue };
        const index = formResponses.findIndex(x => x.key === 'internalIdentifierContratante');
        index != -1 ? formResponses[index].value = fValue : formResponses.push(nField);
    }

    const keyEnableFields = {
        codigoPostalAsegurado: true,
        estadoAsegurado: true,
        telefonoCelularAsegurado: false,
        tipoDePersonaAsegurado: true,
        identificadorPersona: true,
    }

    const keyDisabledFields = {
        codigoPostalAsegurado: true,
        estadoAsegurado: true,
        primerNombreAsegurado: true,
        primerApellidoAsegurado: true,
        segundoApellidoAsegurado: true,
        sexoAsegurado: true,
        fechaNacimientoAsegurado: true,
        fechaDeConstitucionAsegurado: true,
        razonSocialAsegurado: true,
        codigoPostalAsegurado: true,
        coloniaAsegurado: true,

        primerNombreContratante: true,
        segundoNombreContratante: true,
        primerApellidoContratante: true,
        segundoApellidoContratante: true,
        fechaNacimientoContratante: true,
        sexoContratante: true,
        fechaDeConstitucionContratante: true,
        razonSocialContratante: true,
        codigoPostalContratante: true,
        estadoContratante: true,
        coloniaContratante: true,
    }

    const equalKeys = {
        numero: 'nExterior',
        descripcionDomicilio: 'direccion',
        telefono: 'telefonoCelular',
        provinciaDomicilio: 'estado',
        colonia: 'colonia',
        sexo: 'sexo',
        codigoPostal: 'codigoPostal',
        fechaNacimiento: 'fechaNacimiento',
    }

    const equalKeysTransv = {
        piso: 'cantidadPisos'
    }
    const equalKeysContratante = {
        numero: 'nExteriorContratante',
        descripcionDomicilio: 'direccionContratante',
        piso: 'cantidadPisos',
        telefono: 'telefonoCelularContratante',
        colonia: 'coloniaContratante',
        provinciaDomicilio: 'estadoContratante',
        codigoPostal: 'codigoPostalContratante',
    }

    const equalKeysMoral = {
        fechaNacimiento: 'fechaDeConstitucion',
        nombreCompleto: 'razonSocial'
    }

    const enableFields = () => {
        const keys = getKeys(current);
        let newFormResponses = JSON.parse(JSON.stringify(formResponses));
        keys && keys.forEach(keyFe => {
            if ((keyFe && !keyEnableFields[keyFe]) && keyFe !== "tipoDePersonaContratante" && keyFe !== "datosContratanteIgualAsegurado" && keyFe !== 'identificadorPersonaMoral' && keyFe !== 'identificadorPersonaContratanteMoral' && keyFe !== 'identificadorPersona' && keyFe !== 'identificadorPersonaMoral' && !keyFe.includes('identificadorPersona')) {
                disabledFields[keyFe] = false;
                form.resetFields([keyFe]);
                newFormResponses = newFormResponses.filter(value => value.key !== keyFe);
            }
        });
        setDataForm(dataForm => ({ ...dataForm, formResponses: newFormResponses }));
    }

    const autoComplete = (response, keyBtn) => {
        const isContratant = keyBtn === 'Contratante';
        isContratant && form.resetFields(['segundoNombreContratante'])
        const typePerson = formResponses.find(x => x.key === `tipoDePersona${keyBtn}`)?.value;
        setInternalIdentifier(response);
        const keys = Object.keys(response);
        if (info.key.includes("identificadorPersonaContratante")) {
            form.resetFields(["ciudadContratante", "municipioContratante"])
        } else if (info.key.includes("identificadorPersona")) {
            form.resetFields(["ciudadAsegurado", "municipioAsegurado"]);
        }
        keys && keys.length > 0 && keys.forEach(val => {
            let keyLcl = keyBtn ? `${equalKeys[val] ? equalKeys[val] : val}${keyBtn}` : val;
            keyLcl = typePerson === 'personaMoral' && equalKeysMoral[val] ? `${equalKeysMoral[val] + keyBtn}` :
                keyBtn && equalKeys[val] ? `${equalKeys[val] ? equalKeys[val] : val}${keyBtn}` :
                    equalKeysTransv[val] ? equalKeysTransv[val] :
                        getValueTypePerson(val + keyBtn, formResponses) ? getValueTypePerson(val + keyBtn, formResponses) :
                            isContratant && equalKeysContratante[val] ? equalKeysContratante[val] :
                                    keyLcl;
            disabledFields[keyLcl] = keyLcl && keyDisabledFields[keyLcl];

            const item = current.newItems.find(x => x && x.key === keyLcl);

            keyLcl !== 'codigoPostalAsegurado' && form.setFieldsValue({
                [keyLcl]: val === 'pais' || val === 'sexo' || val === 'colonia' || val === 'provinciaDomicilio' ?
                    response[val].split('-')[1].replace(' ', '') : val === 'fechaNacimiento' ? moment(response[val]).format('DD/MM/YYYY') : response[val]
            });
            if (item && keyLcl && keyLcl !== 'codigoPostalAsegurado') {
                let value = val === 'pais' || val === 'sexo' || val === 'colonia' || val === 'provinciaDomicilio' ?
                    response[val].split('-')[0].replace(' ', '') : response[val];

                if (typePerson === 'personaMoral' && (keyLcl === 'sexoAsegurado' || keyLcl === 'sexoContratante')) {
                    value = 'E'
                }
                const index = formResponses.findIndex(x => x.key === keyLcl);
                const newVal = String(response[val]) && String(response[val]).split('-');
                const options = newVal && newVal.length > 1 ?
                    [{ clave: newVal[0].replace(' ', ''), descripcion: newVal[1].replace(' ', '') }] : [];

                if (index != -1) {
                    if(keyLcl==='cantidadPisos'&&value){
                        const validate = new RegExp("^([0-9]*)$").test(value);
                        value=validate?value:''
                    }
                    formResponses[index].value = value;
                    if (keyLcl === "primerNombreAsegurado") {
                        const indexName = formResponses.findIndex(x => x.key === "primerNombreAsegurado");
                        if (indexName !== -1) {
                            const nameComplete = value;
                            formResponses[indexName].value = nameComplete;
                            formResponses[index].value = nameComplete;
                            form.setFieldsValue({ [keyLcl]: nameComplete });
                            setCheckOption(true)
                        }
                    } else {
                        if (keyLcl === 'fechaDeConstitucionAsegurado' || keyLcl === 'fechaDeConstitucionContratante' || keyLcl === 'fechaDeNacimientoContratante' || keyLcl === 'fechaDeNacimientoContratante') {
                            value = getDateFormat(value, 'DD/MM/YYYY')
                        }
                        const valueP = getValueField(keyLcl, formResponses);
                        value !== valueP && form.setFieldsValue({ [keyLcl]: value.toString() });
                    }

                    if (item.type === "select") {
                        formResponses[index].valuesResponse = options
                    }
                } else {
                    item.value = value;
                    if (item.type === "select") {
                        item.valuesResponse = options
                    }
                    formResponses.push(item)
                }

                if(keyLcl==='estadoAsegurado'){
                    const indexCopy = formResponses.findIndex(x => x.key === 'copyestadoAsegurado');
                    indexCopy != -1 ? formResponses[indexCopy].value = value : index!=-1?formResponses.push({...formResponses[index],key:'copyestadoAsegurado'}):formResponses.push({...item,key:'copyestadoAsegurado'});
                }

                const dependencyValue = getDependencyValue(current, keyLcl, value, []);
                if (dependencyValue && dependencyValue.length > 0) {
                    dependencyValue.forEach(x => {
                        const keyItem = Object.keys(x)[0];
                        form.setFieldsValue({ [keyItem]: '' });
                        hiddenFields[keyItem] = x[keyItem];
                    });
                }
            }
            if (keyLcl === "codigoPostalContratante" || keyLcl === 'codigoPostalAsegurado') {
                disabledFields[keyLcl] = keyDisabledFields[keyLcl];
            }
        });
        const keyLcl = 'codigoPostal'
        const valueCP = form.getFieldValue('codigoPostalAsegurado');
        const valueCPService = response[keyLcl];
        if (keyBtn === 'Asegurado' && (valueCP !== valueCPService)) {
            const arrayFields = ['estadoAsegurado', 'coloniaAsegurado', 'nExteriorAsegurado', 'direccionAsegurado', 'cantidadPisos']
            arrayFields.forEach((key) => {
                form.resetFields([key]);
                const indexF = formResponses.findIndex(x => x.key === key);
                if (indexF !== -1) {
                    formResponses[indexF].value = '';
                }
            })
            disabledFields['estadoAsegurado'] = false;
            disabledFields['coloniaAsegurado'] = false;
        } else if (keyBtn === 'Contratante') {
            disabledFields['segundoNombreContratante'] = true;
        } else if (keyBtn === 'Asegurado') {
            disabledFields['segundoNombreAsegurado'] = true;
            disabledFields['estadoAsegurado'] = true;
            disabledFields['coloniaAsegurado'] = false;
        }


        setDataForm({
            data,
            formResponses,
            hiddenFields: hiddenFields,
            disabledFields: disabledFields,
        });

    }


    return (
        <>
            <Form.Item
                label={info.description ? info.description : null}
                name={info && info.key}
                key={key}
                hidden={hiddenFields[info && info.key]}
            >
                <TextField info={info} form={form} onFocusOut={onClick} current={current} />
            </Form.Item>
        </>
    )
}